import React, { Component } from 'react';
import Axios from 'axios';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';

import Config from '@apricityhealth/web-common-lib/Config';

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    DialogActions,
    CircularProgress,
    DialogContent,
    DialogTitle,
    Dialog,
    TextField,
    Button
} from '@material-ui/core/';

import EnhancedTableToolbar from '@apricityhealth/web-common-lib/components/EnhancedTableToolbar';
import getErrorMessage from '@apricityhealth/web-common-lib/utils/getErrorMessage';

function validateEmail(email) {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)

}

class PatientDelegate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dialog: null,
            patientId: props.patientId,
            delegates: [],
            email: '',
            firstName: '',
            lastName: '',
            editIndex: 0,
            progress: null,
            error: null
        }
    }

    componentDidMount() {
        this.getPatientDelegates()
    }

    saveDelegate() {
        const { patientId, email, firstName, lastName } = this.state;
        const savePatientDelegate = {
            url: Config.baseUrl + `${Config.pathPrefix}patients/${patientId}/delegates`,
            method: 'POST',
            headers: { "Authorization": this.props.appContext.state.idToken },
            data: {
                firstName,
                lastName,
                email
            }
        };
        this.setState({ dialog: null, progress: <CircularProgress />, error: null });
        Axios(savePatientDelegate).then((response) => {
            console.log("savePatientDelegate response:", response);
            this.setState({ progress: null, email: '', firstName: '', lastName: '' }, () => this.getPatientDelegates());
        }).catch((error) => {
            console.log("savePatientDelegate  error:", error);
            this.setState({ progress: null, error: getErrorMessage(error) });
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.patientId !== this.props.patientId) {
            this.setState({ delegates: [], patientId: this.props.patientId }, () => this.getPatientDelegates);
        }
    }

    getPatientDelegates() {
        const { patientId } = this.state;
        const getPatientDelegates = {
            url: Config.baseUrl + `${Config.pathPrefix}patients/${patientId}/delegates`,
            method: 'GET',
            headers: { "Authorization": this.props.appContext.state.idToken }
        };

        this.setState({ progress: <CircularProgress />, error: null });

        console.log("getPatientDelegates request:", getPatientDelegates);
        Axios(getPatientDelegates).then((response) => {
            const { delegates } = response.data;
            console.log("getPatientDelegates response:", delegates );
            this.setState({ delegates, progress: null })
        }).catch((err) => {
            console.log("getPatientDelegates error:", err);
            this.setState({ progress: null, error: getErrorMessage(err) });
        });
    }

    handleOnAdd = () => {
        const { email, firstName, lastName } = this.state;

        this.setState({
            dialog: <Dialog open={true}>
                <DialogTitle>Add Delegate</DialogTitle>
                <DialogContent>
                    <TextField style={{ margin: 5, width: '95%' }} label='First Name' value={firstName} onChange={(e) => this.setState({ firstName: e.target.value }, this.handleOnAdd)} />
                    <TextField style={{ margin: 5, width: '95%' }} label='Last Name' value={lastName} onChange={(e) => this.setState({ lastName: e.target.value }, this.handleOnAdd)} />
                    <TextField style={{ margin: 5 , width: '95%'}} label='E-Mail' value={email} onChange={(e) => this.setState({ email: e.target.value }, this.handleOnAdd)} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.setState({ dialog: null, email: '' })}>Cancel</Button>
                    <Button disabled={!validateEmail(this.state.email)} onClick={() => {
                        this.saveDelegate();
                    }}>Add Delegate</Button>
                </DialogActions>
            </Dialog>
        })
    }

    deleteDelegate(index) {
        const { patientId, delegates } = this.state
        const { user: { firstName, lastName, username } } = delegates[index];

        this.setState({dialog: <Dialog open={true}>
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
                Please confirm you want to delete {firstName} {lastName} as a delegate?
            </DialogContent>
            <DialogActions>
                <Button onClick={() => this.setState({dialog: null})}>Cancel</Button>
                <Button onClick={() => {
                    const deletePatientDelegate = {
                        url: Config.baseUrl + `${Config.pathPrefix}patients/${patientId}/delegates/${username}`,
                        method: 'DELETE',
                        headers: { "Authorization": this.props.appContext.state.idToken },
                    };

                    this.setState({ dialog: null, progress: <CircularProgress />, error: null });
                    Axios(deletePatientDelegate).then((response) => {
                        console.log("deletePatientDelegate response:", response);
                        this.setState({ progress: null }, () => this.getPatientDelegates());
                    }).catch((err) => {
                        console.log("deletePatientDelegate  error:", err);
                        this.setState({ progress: null, error: getErrorMessage(err) });
                    });
                }}>Confirm</Button>
            </DialogActions>
        </Dialog>})
    }


    render() {
        const { delegates, dialog, progress, error } = this.state;
        const delegateRows = () => {
            const tableRows = []
            if (Array.isArray(delegates)) {
                delegates.forEach((delegate, i) => {
                    if (delegate.user) {
                        tableRows.push((
                            <TableRow
                                hover
                                tabIndex={i}
                                key={i}
                            >
                                <TableCell>
                                    {delegate.user.username}
                                </TableCell>
                                <TableCell>
                                    {delegate.user.email}
                                </TableCell>
                                <TableCell>
                                    {delegate.user.firstName}
                                </TableCell>
                                <TableCell>
                                    {delegate.user.lastName}
                                </TableCell>
                                <TableCell>
                                    <IconButton
                                        aria-label="Delete" s
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            this.deleteDelegate(i)
                                        }} >
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ));
                    }
                })
            }
            return tableRows
        }
        return (
            <Paper>
                <EnhancedTableToolbar
                    title='Patient Delegates'
                    onAdd={this.handleOnAdd}
                />
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>User ID</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>First Name</TableCell>
                            <TableCell>Last Name</TableCell>
                            <TableCell>Delete</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {delegateRows()}
                    </TableBody>
                </Table>
                {progress}
                {dialog}
                <span style={{ color: 'red' }}>{error}</span>
            </Paper>
        )
    }
}

export default PatientDelegate;